if (!customElements.get('tiered-buy-box')) {
  customElements.define(
    'tiered-buy-box',
    class TieredBuyBox extends HTMLElement {
      constructor() {
        super();

        this.sectionId = this.dataset.sectionId;
        this.variantId = this.dataset.variantId;
        this.addonVariantId = this.dataset.addonVariantId;

        this.tierWrappers = Array.from(this.querySelectorAll('[data-tier]'));
        this.addonWrapper = this.querySelector('[data-addon]');
        this.addonInput = this.querySelector('[data-addon-toggle]');
        this.submitButton = this.querySelector('[data-add-to-cart]');
        this.submitButtonText = this.submitButton.querySelector('[data-text]');
        this.spinner = this.querySelector('.loading__spinner');
        this.errorContainer = this.querySelector('.tiered-buy-box__error');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.tierWrappers.forEach((tier) => {
          const input = tier.querySelector('input[type="radio"]');
          input.addEventListener('change', this.onTierChange.bind(this));
        });

        if (this.addonInput) {
          this.addonInput.addEventListener('change', this.onAddonChange.bind(this));
        }

        this.submitButton.addEventListener('click', this.onSubmit.bind(this));
      }

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event.data.sectionId || event.data.sectionId !== this.sectionId) return;
          this.variantId = event.data.variant ? event.data.variant.id : undefined;
          this.toggleAvailability(event.data.variant);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      onTierChange(event) {
        this.tierWrappers.forEach((tier) => tier.classList.remove('tiered-buy-box__tier--selected'));
        event.target.closest('[data-tier]').classList.add('tiered-buy-box__tier--selected');
      }

      onAddonChange(event) {
        if (this.addonWrapper) this.addonWrapper.classList.toggle('tiered-buy-box__addon--checked', event.target.checked);
      }

      toggleAvailability(variant) {
        const available = Boolean(variant && variant.available);
        this.submitButton.toggleAttribute('disabled', !available);
        if (this.submitButtonText) {
          this.submitButtonText.textContent = available
            ? this.dataset.addToCartText
            : this.dataset.soldOutText;
        }
      }

      get selectedTier() {
        const checked = this.querySelector('[data-tier] input[type="radio"]:checked');
        const wrapper = checked ? checked.closest('[data-tier]') : null;
        return {
          variantId: (wrapper && wrapper.dataset.variantId) || this.variantId,
          quantity: wrapper ? parseInt(wrapper.dataset.quantity, 10) : 1,
        };
      }

      onSubmit(event) {
        event.preventDefault();
        const { variantId, quantity } = this.selectedTier;

        if (
          !variantId ||
          this.submitButton.hasAttribute('disabled') ||
          this.submitButton.classList.contains('loading')
        ) {
          return;
        }

        const items = [{ id: variantId, quantity }];

        if (this.addonInput && this.addonInput.checked && this.addonVariantId) {
          items.push({ id: this.addonVariantId, quantity: 1 });
        }

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        if (this.spinner) this.spinner.classList.remove('hidden');
        this.hideError();

        const config = fetchConfig('json');
        const body = { items };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = JSON.stringify(body);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message);
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'tiered-buy-box',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'tiered-buy-box',
              productVariantId: variantId,
              cartData: response,
            });

            if (response.key === undefined && Array.isArray(response.items) && response.items.length > 0) {
              response.key = response.items[0].key;
            }

            if (typeof this.cart.renderContents === 'function') this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
            this.showError();
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (this.spinner) this.spinner.classList.add('hidden');
          });
      }

      showError(message) {
        if (!this.errorContainer) return;
        this.errorContainer.textContent = message || (window.cartStrings && window.cartStrings.error) || '';
        this.errorContainer.hidden = false;
      }

      hideError() {
        if (!this.errorContainer) return;
        this.errorContainer.hidden = true;
      }
    }
  );
}
